import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-jweb-mpvertx-servlet',
	templateUrl:'./JWebMPVertxServletPluginCompPage.html',
	styles: [],
	styleUrls:['./JWebMPVertxServletPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class JWebMPVertxServletPluginCompPage
{
	mdContent_1051 = `\`\`\`java
import com.jwebmp.vertx.JWebMPVertxServlet;
\`\`\``;
	mdContent_1052 = `\`\`\`java
JWebMPVertxServlet()
\`\`\``;
	mdContent_1053 = `\`\`\`java
@PageConfiguration(url = "/")
public class HomePage extends Page&lt;HomePage&gt; {
    public HomePage() {
        getBody().add(new H1&lt;&gt;().setText("Hello"));
    }
}
// JWebMPVertxServlet renders this page at GET /
\`\`\``;
}
